/*
 * What a failed inbox write may say (frontend performance plan, W5, F07). A refusal is the server's
 * answer: nothing changed, and saying so is true. A write whose answer never came, or came as a
 * server failure, may have been committed before it failed: saying "nothing changed" there could
 * be false, so the screen says it could not confirm, and reads the truth again.
 */
import { ApiError } from "../http.ts";

export type WriteOutcome =
  | { readonly kind: "refused"; readonly code: string | null }
  | { readonly kind: "unknown" };

export function writeOutcome(error: unknown): WriteOutcome {
  if (error instanceof ApiError && !error.transient) return { kind: "refused", code: error.code };
  return { kind: "unknown" };
}

const REASONS: Readonly<Record<string, string>> = {
  workspace_not_found: "this workspace is not available any more",
  not_found: "the conversation is no longer here",
  invalid_request: "the request was not valid",
  // A rep's word names the lead message it is about; one that is no longer the newest is refused.
  stale_message: "a newer reply came in, so read it first",
};

/** "Could not snooze: …. Nothing changed." or "Could not confirm the snooze. Showing the latest." */
export function failedWriteText(what: { verb: string; noun: string }, outcome: WriteOutcome) {
  if (outcome.kind === "unknown") return `Could not confirm the ${what.noun}. Showing the latest.`;
  const reason = (outcome.code && REASONS[outcome.code]) || "the server refused it";
  return `Could not ${what.verb}: ${reason}. Nothing changed.`;
}
